var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"status",staticClass:"status",class:_vm.status},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icons[_vm.status]))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }